import { Inject, Injectable } from "@angular/core";
import { AlertController, ToastController } from "ionic-angular";
import { TranslateService } from "@ngx-translate/core";
import { HttpClient, HttpHeaders } from "@angular/common/http";
import { OdConfig } from "../od-config";
import { ApiResultCode, ApiResultError, CheckUtils } from "..";
var httpOptions = {
    headers: new HttpHeaders({
        'Content-Type': 'application/json'
    })
};
var ApiEndPoint = /** @class */ (function () {
    function ApiEndPoint(config, http, alertCtrl, toastCtrl, translate) {
        this.config = config;
        this.http = http;
        this.alertCtrl = alertCtrl;
        this.toastCtrl = toastCtrl;
        this.translate = translate;
        this.cpAPIUrl = (config.url ? config.url : ('https://' + window.location.host)) + (config.port ? (':' + config.port) : config.port) + '/rest/' + config.version + '/';
        this.fileUrl = (config.url ? config.url : ('https://' + window.location.host)) + config.fileUrl;
        this.excludeErrorsAlert = [ApiResultCode.ERROR_CANNOT_FIND_USER];
    }
    ApiEndPoint.prototype.buildUrl = function (path, params) {
        var url = this.cpAPIUrl + path;
        if (params.length !== 0) {
            url += '?' + params.join('&');
        }
        return url;
    };
    ApiEndPoint.prototype.post = function (url, body, delegateError, withToast) {
        var _this = this;
        if (delegateError === void 0) { delegateError = false; }
        var params = [];
        for (var _i = 4; _i < arguments.length; _i++) {
            params[_i - 4] = arguments[_i];
        }
        return this.http.post(this.buildUrl(url, params), body, httpOptions)
            .map(function (res) {
            var apiResultCode = null;
            if (res != null) {
                if (res.code === ApiResultCode.SUCCESS)
                    return res.data;
                else if (res.code) {
                    apiResultCode = _this.getApiResultCode(res.code);
                }
                else {
                    return res;
                }
            }
            if (apiResultCode == null) {
                apiResultCode = _this.getApiResultCode(ApiResultCode.UNKNOWN_ERROR);
            }
            if (!delegateError && (apiResultCode.code !== ApiResultCode.ERROR_COOKIE_LOGIN_FAILED &&
                apiResultCode.code !== ApiResultCode.ERROR_AUTHENTICATION_FROM_TOKEN_FAILED &&
                apiResultCode.code !== ApiResultCode.ERROR_PORTAL_DISABLED &&
                apiResultCode.code !== ApiResultCode.ERROR_LOGIN_WITH_WRONG_ORG))
                _this.errorAlert(apiResultCode, withToast);
            return apiResultCode;
        });
    };
    ApiEndPoint.prototype.get = function (url, delegateError, withToast) {
        var _this = this;
        if (delegateError === void 0) { delegateError = false; }
        var params = [];
        for (var _i = 3; _i < arguments.length; _i++) {
            params[_i - 3] = arguments[_i];
        }
        var args = [];
        for (var _a = 0, params_1 = params; _a < params_1.length; _a++) {
            var param = params_1[_a];
            if (!CheckUtils.isEmpty(param)) {
                args.push(param);
            }
        }
        return this.http.get(this.buildUrl(url, args), httpOptions)
            .map(function (res) {
            var apiResultCode = null;
            if (res != null) {
                if (res.code === ApiResultCode.SUCCESS)
                    return res.data;
                if (res.code === ApiResultCode.ERROR_AUTHENTICATION_FROM_TOKEN_FAILED && !CheckUtils.isEmpty(_this._connectHandler))
                    _this._connectHandler();
                apiResultCode = _this.getApiResultCode(res.code);
            }
            if (apiResultCode == null) {
                apiResultCode = _this.getApiResultCode(ApiResultCode.UNKNOWN_ERROR);
            }
            if (!delegateError && (apiResultCode.code !== ApiResultCode.ERROR_COOKIE_LOGIN_FAILED &&
                apiResultCode.code !== ApiResultCode.ERROR_AUTHENTICATION_FROM_TOKEN_FAILED &&
                apiResultCode.code !== ApiResultCode.ERROR_PORTAL_DISABLED &&
                apiResultCode.code !== ApiResultCode.ERROR_SECURITY_ACCESS &&
                apiResultCode.code !== ApiResultCode.ERROR_LOGIN_WITH_WRONG_ORG))
                _this.errorAlert(apiResultCode, withToast);
            return apiResultCode;
        });
    };
    ApiEndPoint.prototype.upload = function (method, url, formData, onProgress, onFail, onLoadEnd, withToast) {
        var _this = this;
        var params = [];
        for (var _i = 7; _i < arguments.length; _i++) {
            params[_i - 7] = arguments[_i];
        }
        var xhr = new XMLHttpRequest();
        xhr.open(method, this.buildUrl(url, params));
        xhr.setRequestHeader('X-Requested-With', 'XMLHttpRequest');
        xhr.onloadstart = function (evt) {
            if (onProgress != null)
                onProgress(1);
        };
        xhr.onprogress = function (event) {
            if (onProgress != null)
                onProgress(event.loaded / event.total * 100);
        };
        xhr.onloadend = function (evt) {
            if (onLoadEnd == null)
                return;
            var apiResultError = null;
            var response = JSON.parse(xhr.response);
            if (response != null) {
                if (response.code === ApiResultCode.SUCCESS) {
                    onLoadEnd(response.data);
                    return;
                }
                else if (response.code) {
                    apiResultError = _this.getApiResultCode(response.code);
                }
                else {
                    return onLoadEnd(response);
                }
            }
            if (apiResultError == null) {
                apiResultError = _this.getApiResultCode(ApiResultCode.UNKNOWN_ERROR);
            }
            _this.errorAlert(apiResultError, withToast);
            onLoadEnd(apiResultError);
        };
        xhr.onabort = function (evt) {
            var apiResultError = _this.getApiResultCode(ApiResultCode.UPLOAD_CANCEL);
            if (onFail != null)
                onFail(apiResultError);
            _this.errorAlert(apiResultError, withToast);
        };
        xhr.onerror = function (evt) {
            var apiResultCode = _this.getApiResultCode(ApiResultCode.UPLOAD_ERROR);
            if (onFail != null)
                onFail(apiResultCode);
            _this.errorAlert(apiResultCode, withToast);
        };
        xhr.send(formData);
        return function () { return xhr.abort(); };
    };
    Object.defineProperty(ApiEndPoint.prototype, "connectHandler", {
        set: function (handler) {
            this._connectHandler = handler;
        },
        enumerable: true,
        configurable: true
    });
    ApiEndPoint.prototype.getApiResultCode = function (error) {
        var name = "";
        this.translate.get('Errors.' + error + '.name').subscribe(function (res) { return name = res; });
        var description = "";
        this.translate.get('Errors.' + error + '.description').subscribe(function (res) { return description = res; });
        return new ApiResultError(error, name, description);
    };
    ApiEndPoint.prototype.errorAlert = function (apiErrorResult, withToast) {
        var _this = this;
        if (withToast === void 0) { withToast = true; }
        if (this.excludeErrorsAlert.indexOf(apiErrorResult.code) > -1)
            return;
        this.translate.get("OK").subscribe(function (res) {
            if (withToast) {
                if (CheckUtils.isEmpty(_this.toast)) {
                    _this.toast = _this.toastCtrl.create({
                        message: apiErrorResult.name + ":" + apiErrorResult.description,
                        duration: 3000,
                        position: 'bottom'
                    });
                    if (!CheckUtils.isEmpty(apiErrorResult.category)) {
                        _this.toast.setCssClass("toast-wrapper" + apiErrorResult.category.toString().toLowerCase());
                    }
                    _this.toast.present().then(function () {
                        _this.toast.onDidDismiss(function () { return _this.toast = null; });
                    });
                }
            }
            else if (CheckUtils.isEmpty(_this.alert)) {
                _this.alert = _this.alertCtrl.create({
                    title: apiErrorResult.name,
                    subTitle: apiErrorResult.description,
                    buttons: [res]
                });
                if (!CheckUtils.isEmpty(apiErrorResult.category)) {
                    _this.toast.setCssClass("alert-wrapper" + apiErrorResult.category.toString().toLowerCase());
                }
                _this.alert.present().then(function () {
                    _this.alert.onDidDismiss(function () { return _this.alert = null; });
                });
            }
        });
    };
    ApiEndPoint.decorators = [
        { type: Injectable },
    ];
    /** @nocollapse */
    ApiEndPoint.ctorParameters = function () { return [
        { type: OdConfig, decorators: [{ type: Inject, args: ['config',] },] },
        { type: HttpClient, },
        { type: AlertController, },
        { type: ToastController, },
        { type: TranslateService, },
    ]; };
    return ApiEndPoint;
}());
export { ApiEndPoint };
//# sourceMappingURL=api-end-point.js.map


//////////////////
// WEBPACK FOOTER
// ../od-ts/dist/endpoints/api-end-point.js
// module id = 38
// module chunks = 14